<template>
  <!-- start 试用 -->
  <div class="dialog-box" v-if="open" @click="preventClick">
    <!-- start 弹窗 -->
    <div class="on-trial">
      <!-- start 头部 -->
      <div class="on-trial-header">
        <img
          class="on-trial-header-icon"
          src="@/assets/images/xiao-header-icon.png"
        />
        <span class="on-trial-header-title">试用提醒</span>
      </div>
      <!-- end 头部 -->
      <!-- start 内容 -->
      <div class="on-trial-content">
        <!-- <div class="count-down">{{ transverter(counter) }}</div> -->
        <div class="hint middle" style="height: 45px">
          <!-- <span style="color: #3088ff">●</span> -->
          试用版每个功能只能体验30秒，如果您喜欢这个软件，<br />请购买正式版本
        </div>
        <!-- <div class="hint">必须等待1分钟才能继续使用（除此外没有功能限制）</div> -->
        <!-- <div class="hint">
          <span style="color: #3088ff">●</span>
          软件的研发倾注了作者大量的心血，如果您喜欢这个软件，
        </div>
        <div class="hint">请购买正版支持我们吧</div> -->
        <div class="btn-group">
          <div class="btn purchase" @click="buyFun">立即购买</div>
          <div
            class="btn"
            style="margin-left: 20px"
            :class="true ? 'continue' : 'not-continue'"
            @click="continueFun"
          >
            返回首页
          </div>
        </div>
      </div>
      <!-- end 内容 -->
    </div>
    <!-- end 弹窗 -->
  </div>
  <!-- end 试用 -->
</template>

<script>
export default {
  data() {
    return {
      // 计时数
      counter: 0,
      // 时间触发器对象
      timer: null,
      // 是否继续
      isContinue: false,
    };
  },
  props: {
    open: {
      typeof: Boolean,
      default: false,
    },
  },
  watch: {
    // 监听弹窗
    open: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          let isQuit = localStorage.getItem("isQuit");
          if (isQuit) {
            localStorage.setItem("staleDatedCount", 60);
            localStorage.setItem("isQuit", false);
          }
          this.counter = localStorage.getItem("staleDatedCount");
          this.isContinue = false;
          this.countDown();
        }
      },
    },
  },
  methods: {
    // 立即购买
    buyFun() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      localStorage.setItem("staleDatedCount", 60);
      this.$emit("buyFun");
    },
    // 继续
    continueFun() {
      // if (this.isContinue) {
      this.$emit("close");
      this.$router.push({ name: "Home" }).catch(() => {});
      // }
    },
    // 转换器
    transverter(counter) {
      let remainder = counter % 60;
      if (remainder == 0) {
        remainder = "00";
      } else if (remainder < 10) {
        remainder = "0" + remainder;
      }
      return parseInt(counter / 60) + ":" + remainder;
    },
    // 倒计时
    countDown() {
      this.timer = setInterval(() => {
        this.counter = localStorage.getItem("staleDatedCount");
        if (!this.counter) {
          this.counter = 60;
          localStorage.setItem("staleDatedCount", this.counter);
        }
        this.counter--;
        localStorage.setItem("staleDatedCount", this.counter);
        if (this.counter <= 0) {
          localStorage.setItem("staleDatedCount", 60);
          if (this.timer) {
            this.isContinue = true;
            clearTimeout(this.timer);
          }
        }
      }, 1000);
    },
    // 防止点击
    preventClick() {},
  },
};
</script>

<style lang="scss" scoped>
.dialog-box {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(#000000, 0.4);
  .on-trial {
    width: 450px;
    height: 170px;
    padding: 5px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    outline: none;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.16);
    .on-trial-header {
      display: flex;
      align-items: center;
      margin-left: 10px;
      height: 30px;
      .on-trial-header-icon {
        width: 16px;
        height: 16px;
      }
      .on-trial-header-title {
        font-size: 16px;
        font-weight: 400;
        color: #282a43;
        line-height: 22px;
        margin-left: 7px;
        font-weight: bold;
      }
    }
    .on-trial-content {
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 20px 10px;
      .count-down {
        font-size: 50px;
        font-weight: bold;
        color: #3088ff;
        margin: 14px 0;
      }
      .hint {
        font-size: 14px;
        font-weight: 400;
        color: #282a43;
        width: 380px;
        line-height: 22px;
        text-align: center;
        &.middle {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .btn-group {
        margin-top: 24px;
        display: flex;
        .btn {
          width: 128px;
          height: 36px;
          border-radius: 3px 3px 3px 3px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          cursor: pointer;
        }
        .purchase {
          background: linear-gradient(90deg, #ffebce 0%, #f8d393 100%);
          color: #562208;
          font-weight: bold;
        }
        .not-continue {
          color: #bebebe;
          background: #ececec;
        }
        .continue {
          background: #3088ff;
          color: #ffffff;
        }
      }
    }
  }
}
</style>

